import { globalColors } from "../../../Utils/colors";

interface ButtonIconProps {
  color?: string;
  disabled: Boolean;
  onClick?: () => void;
}

interface SidebarIconProps {
  isSelected: Boolean;
}

interface PreviewIconProps {
  isSelected: Boolean;
}

const PublishIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_302_4466)">
        <path
          d="M9.54395 15.828L7.17836 15.828C6.78508 15.828 6.46868 15.5116 6.46868 15.1183L6.46868 10.1505L3.8754 10.1505C3.34906 10.1505 3.08589 9.51479 3.45847 9.14221L7.95605 4.64167C8.17782 4.4199 8.54153 4.4199 8.76331 4.64167L13.2668 9.14221C13.6394 9.51479 13.3762 10.1505 12.8499 10.1505L10.2536 10.1505L10.2536 15.1183C10.2536 15.5116 9.93723 15.828 9.54395 15.828Z"
          fill={
            disabled
              ? globalColors.disabledColor
              : color
                ? color
                : globalColors.white
          }
        />
        <rect
          x="14.5547"
          y="3.44086"
          width="12.3871"
          height="2.75269"
          rx="1.03226"
          transform="rotate(-180 14.5547 3.44086)"
          fill={
            disabled
              ? globalColors.disabledColor
              : color
                ? color
                : globalColors.white
          }
        />
      </g>
      <defs>
        <clipPath id="clip0_302_4466">
          <rect
            width="15.1398"
            height="15.1398"
            fill={disabled ? globalColors.disabledColor : globalColors.white}
            transform="translate(15.9307 15.828) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const OpenFormIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66667 2.66666H4C3.64638 2.66666 3.30724 2.80713 3.05719 3.05718C2.80714 3.30723 2.66667 3.64637 2.66667 3.99999V12C2.66667 12.3536 2.80714 12.6928 3.05719 12.9428C3.30724 13.1928 3.64638 13.3333 4 13.3333H12C12.3536 13.3333 12.6928 13.1928 12.9428 12.9428C13.1929 12.6928 13.3333 12.3536 13.3333 12V9.33332M8 7.99999L13.3333 2.66666M13.3333 2.66666V5.99999M13.3333 2.66666H10" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" stroke={disabled ? globalColors.disabledColor : globalColors.white} />
    </svg>
  );
};

const UnPublishIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    >
      <path
        fill={disabled ? globalColors.disabledColor : globalColors.white}
        d="m20.475 23.3l-2.95-2.95q-1.2.8-2.587 1.225T12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-1.55.425-2.937T3.65 6.475L.675 3.5L2.1 2.075l19.8 19.8zM12 20q1.125 0 2.138-.3t1.912-.825L12.175 15L10.6 16.6l-4.25-4.25l1.4-1.4l2.85 2.85l.175-.2l-5.65-5.65q-.525.9-.825 1.913T4 12q0 3.325 2.338 5.663T12 20m8.375-2.5L18.9 16.025q.525-.875.813-1.888T20 12q0-3.325-2.337-5.663T12 4q-1.125 0-2.137.288T7.975 5.1L6.5 3.625q1.2-.775 2.588-1.2T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 1.525-.425 2.913t-1.2 2.587m-5.325-5.35l-1.4-1.4l2.6-2.6l1.4 1.4zM10.6 13.4"
      />
    </svg>
  );
};

const PreviewIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4563 9.01075C8.31651 9.01075 9.04781 8.70979 9.65019 8.10787C10.2521 7.50549 10.5531 6.77419 10.5531 5.91398C10.5531 5.05376 10.2521 4.32246 9.65019 3.72008C9.04781 3.11816 8.31651 2.8172 7.4563 2.8172C6.59608 2.8172 5.86479 3.11816 5.26241 3.72008C4.66049 4.32246 4.35952 5.05376 4.35952 5.91398C4.35952 6.77419 4.66049 7.50549 5.26241 8.10787C5.86479 8.70979 6.59608 9.01075 7.4563 9.01075ZM7.4563 7.77204C6.94017 7.77204 6.50157 7.59128 6.14051 7.22976C5.77899 6.8687 5.59823 6.43011 5.59823 5.91398C5.59823 5.39785 5.77899 4.95902 6.14051 4.5975C6.50157 4.23644 6.94017 4.05591 7.4563 4.05591C7.97243 4.05591 8.41125 4.23644 8.77277 4.5975C9.13383 4.95902 9.31436 5.39785 9.31436 5.91398C9.31436 6.43011 9.13383 6.8687 8.77277 7.22976C8.41125 7.59128 7.97243 7.77204 7.4563 7.77204ZM7.4563 11.0753C5.86203 11.0753 4.4054 10.6539 3.08641 9.8111C1.76741 8.96785 0.76956 7.82939 0.0928575 6.3957C0.0584488 6.33835 0.0355098 6.26655 0.0240403 6.1803C0.0125708 6.09451 0.00683594 6.00573 0.00683594 5.91398C0.00683594 5.82222 0.0125708 5.73322 0.0240403 5.64697C0.0355098 5.56117 0.0584488 5.4896 0.0928575 5.43226C0.76956 3.99856 1.76741 2.86033 3.08641 2.01755C4.4054 1.17431 5.86203 0.752686 7.4563 0.752686C9.05056 0.752686 10.5072 1.17431 11.8262 2.01755C13.1452 2.86033 14.143 3.99856 14.8197 5.43226C14.8541 5.4896 14.8771 5.56117 14.8886 5.64697C14.9 5.73322 14.9058 5.82222 14.9058 5.91398C14.9058 6.00573 14.9 6.09451 14.8886 6.1803C14.8771 6.26655 14.8541 6.33835 14.8197 6.3957C14.143 7.82939 13.1452 8.96785 11.8262 9.8111C10.5072 10.6539 9.05056 11.0753 7.4563 11.0753ZM7.4563 9.69892C8.75236 9.69892 9.94244 9.35759 11.0265 8.67492C12.1102 7.99271 12.9387 7.0724 13.5122 5.91398C12.9387 4.75555 12.1102 3.83501 11.0265 3.15234C9.94244 2.47013 8.75236 2.12903 7.4563 2.12903C6.16024 2.12903 4.97016 2.47013 3.88606 3.15234C2.80242 3.83501 1.97386 4.75555 1.40038 5.91398C1.97386 7.0724 2.80242 7.99271 3.88606 8.67492C4.97016 9.35759 6.16024 9.69892 7.4563 9.69892Z"
        fill={
          disabled
            ? globalColors.disabledColor
            : color
              ? color
              : globalColors.white
        }
      />
    </svg>
  );
};


const ShareIcon = ({ color, disabled }: ButtonIconProps) => {
  return (

    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
    d="M 18 2 A 3 3 0 0 0 15 5 A 3 3 0 0 0 15.054688 5.5605469 L 7.9394531 9.7109375 A 3 3 0 0 0 6 9 A 3 3 0 0 0 3 12 A 3 3 0 0 0 6 15 A 3 3 0 0 0 7.9355469 14.287109 L 15.054688 18.439453 A 3 3 0 0 0 15 19 A 3 3 0 0 0 18 22 A 3 3 0 0 0 21 19 A 3 3 0 0 0 18 16 A 3 3 0 0 0 16.0625 16.712891 L 8.9453125 12.560547 A 3 3 0 0 0 9 12 A 3 3 0 0 0 8.9453125 11.439453 L 16.060547 7.2890625 A 3 3 0 0 0 18 8 A 3 3 0 0 0 21 5 A 3 3 0 0 0 18 2 z"
        fill={
          disabled
            ? globalColors.disabledColor
            : color
              ? color
              : globalColors.white
        }
      />
    </svg>)
}
const SaveIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.34119 12.4516C1.96269 12.4516 1.63856 12.317 1.3688 12.0477C1.0995 11.7779 0.964844 11.4538 0.964844 11.0753V1.44086C0.964844 1.06236 1.0995 0.738235 1.3688 0.468471C1.63856 0.199166 1.96269 0.0645142 2.34119 0.0645142H10.0315C10.215 0.0645142 10.39 0.0989228 10.5566 0.16774C10.7227 0.236557 10.8688 0.334048 10.995 0.460213L12.9562 2.4215C13.0824 2.54767 13.1799 2.69379 13.2487 2.85987C13.3175 3.02641 13.3519 3.20143 13.3519 3.38494V11.0753C13.3519 11.4538 13.2173 11.7779 12.948 12.0477C12.6782 12.317 12.3541 12.4516 11.9756 12.4516H2.34119ZM11.9756 3.40215L10.0143 1.44086H2.34119V11.0753H11.9756V3.40215ZM7.15839 10.3871C7.73187 10.3871 8.21932 10.1864 8.62076 9.78495C9.02219 9.38351 9.22291 8.89606 9.22291 8.32258C9.22291 7.7491 9.02219 7.26165 8.62076 6.86021C8.21932 6.45878 7.73187 6.25806 7.15839 6.25806C6.58492 6.25806 6.09746 6.45878 5.69603 6.86021C5.29459 7.26165 5.09388 7.7491 5.09388 8.32258C5.09388 8.89606 5.29459 9.38351 5.69603 9.78495C6.09746 10.1864 6.58492 10.3871 7.15839 10.3871ZM3.71753 4.88172H8.53474C8.72972 4.88172 8.89327 4.81565 9.0254 4.68353C9.15707 4.55186 9.22291 4.38853 9.22291 4.19355V2.8172C9.22291 2.62222 9.15707 2.45867 9.0254 2.32654C8.89327 2.19487 8.72972 2.12903 8.53474 2.12903H3.71753C3.52255 2.12903 3.35899 2.19487 3.22687 2.32654C3.0952 2.45867 3.02936 2.62222 3.02936 2.8172V4.19355C3.02936 4.38853 3.0952 4.55186 3.22687 4.68353C3.35899 4.81565 3.52255 4.88172 3.71753 4.88172Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
    </svg>
  );
};

const AddIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99967 0.666687C6.36786 0.666687 6.66634 0.965164 6.66634 1.33335V10.6667C6.66634 11.0349 6.36786 11.3334 5.99967 11.3334C5.63148 11.3334 5.33301 11.0349 5.33301 10.6667V1.33335C5.33301 0.965164 5.63148 0.666687 5.99967 0.666687Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666504 6.00004C0.666504 5.63185 0.964981 5.33337 1.33317 5.33337H10.6665C11.0347 5.33337 11.3332 5.63185 11.3332 6.00004C11.3332 6.36823 11.0347 6.66671 10.6665 6.66671H1.33317C0.964981 6.66671 0.666504 6.36823 0.666504 6.00004Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
    </svg>
  );
};

const DeleteIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.18262 4.67743C2.18262 4.29736 2.49072 3.98926 2.87079 3.98926H15.2579C15.638 3.98926 15.9461 4.29736 15.9461 4.67743C15.9461 5.0575 15.638 5.3656 15.2579 5.3656H2.87079C2.49072 5.3656 2.18262 5.0575 2.18262 4.67743Z"
        fill={disabled ? globalColors.disabledColor : globalColors.headingBlack}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6886 2.61291C7.50609 2.61291 7.33105 2.68541 7.20199 2.81447C7.07293 2.94353 7.00043 3.11857 7.00043 3.30108V3.98925H11.1295V3.30108C11.1295 3.11857 11.057 2.94353 10.9279 2.81447C10.7988 2.68541 10.6238 2.61291 10.4413 2.61291H7.6886ZM12.5058 3.98925V3.30108C12.5058 2.75354 12.2883 2.22842 11.9011 1.84125C11.514 1.45408 10.9888 1.23656 10.4413 1.23656H7.6886C7.14106 1.23656 6.61594 1.45408 6.22877 1.84125C5.8416 2.22842 5.62409 2.75354 5.62409 3.30108V3.98925H4.24774C3.86768 3.98925 3.55957 4.29736 3.55957 4.67743V14.3118C3.55957 14.8594 3.77708 15.3845 4.16425 15.7717C4.55142 16.1588 5.07654 16.3764 5.62409 16.3764H12.5058C13.0534 16.3764 13.5785 16.1588 13.9656 15.7717C14.3528 15.3845 14.5703 14.8594 14.5703 14.3118V4.67743C14.5703 4.29736 14.2622 3.98925 13.8822 3.98925H12.5058ZM4.93591 5.3656V14.3118C4.93591 14.4943 5.00842 14.6694 5.13748 14.7984C5.26653 14.9275 5.44157 15 5.62409 15H12.5058C12.6883 15 12.8634 14.9275 12.9924 14.7984C13.1215 14.6694 13.194 14.4943 13.194 14.3118V5.3656H4.93591Z"
        fill={disabled ? globalColors.disabledColor : globalColors.headingBlack}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68817 7.43011C8.06824 7.43011 8.37634 7.73822 8.37634 8.11829V12.2473C8.37634 12.6274 8.06824 12.9355 7.68817 12.9355C7.30811 12.9355 7 12.6274 7 12.2473V8.11829C7 7.73822 7.30811 7.43011 7.68817 7.43011Z"
        fill={disabled ? globalColors.disabledColor : globalColors.headingBlack}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4411 7.43011C10.8212 7.43011 11.1293 7.73822 11.1293 8.11829V12.2473C11.1293 12.6274 10.8212 12.9355 10.4411 12.9355C10.061 12.9355 9.75293 12.6274 9.75293 12.2473V8.11829C9.75293 7.73822 10.061 7.43011 10.4411 7.43011Z"
        fill={disabled ? globalColors.disabledColor : globalColors.headingBlack}
      />
    </svg>
  );
};

const SettingsIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_293_4447)">
        <path
          d="M8.47326 1.92474H8.17046C7.80543 1.92474 7.45535 2.06975 7.19724 2.32787C6.93912 2.58598 6.79412 2.93606 6.79412 3.30109V3.42496C6.79387 3.66632 6.73016 3.90337 6.60937 4.11233C6.48858 4.32129 6.31497 4.49482 6.10594 4.6155L5.81003 4.78754C5.6008 4.90834 5.36346 4.97194 5.12186 4.97194C4.88026 4.97194 4.64292 4.90834 4.43369 4.78754L4.33046 4.73249C4.01463 4.5503 3.63942 4.50088 3.28719 4.59506C2.93496 4.68925 2.63449 4.91935 2.45175 5.23485L2.30035 5.49636C2.11817 5.81218 2.06874 6.18739 2.16293 6.53963C2.25712 6.89186 2.48722 7.19232 2.80272 7.37507L2.90594 7.44388C3.11396 7.56398 3.28693 7.73642 3.40766 7.94407C3.52838 8.15172 3.59267 8.38735 3.59412 8.62754V8.97851C3.59508 9.22103 3.53194 9.45951 3.41109 9.66978C3.29024 9.88006 3.11598 10.0547 2.90594 10.1759L2.80272 10.2379C2.48722 10.4206 2.25712 10.7211 2.16293 11.0733C2.06874 11.4255 2.11817 11.8007 2.30035 12.1166L2.45175 12.3781C2.63449 12.6936 2.93496 12.9237 3.28719 13.0179C3.63942 13.1121 4.01463 13.0626 4.33046 12.8804L4.43369 12.8254C4.64292 12.7046 4.88026 12.641 5.12186 12.641C5.36346 12.641 5.6008 12.7046 5.81003 12.8254L6.10594 12.9974C6.31497 13.1181 6.48858 13.2916 6.60937 13.5006C6.73016 13.7096 6.79387 13.9466 6.79412 14.188V14.3118C6.79412 14.6769 6.93912 15.027 7.19724 15.2851C7.45535 15.5432 7.80543 15.6882 8.17046 15.6882H8.47326C8.83829 15.6882 9.18836 15.5432 9.44648 15.2851C9.70459 15.027 9.8496 14.6769 9.8496 14.3118V14.188C9.84985 13.9466 9.91356 13.7096 10.0343 13.5006C10.1551 13.2916 10.3287 13.1181 10.5378 12.9974L10.8337 12.8254C11.0429 12.7046 11.2803 12.641 11.5219 12.641C11.7635 12.641 12.0008 12.7046 12.21 12.8254L12.3133 12.8804C12.6291 13.0626 13.0043 13.1121 13.3565 13.0179C13.7088 12.9237 14.0092 12.6936 14.192 12.3781L14.3434 12.1097C14.5255 11.7939 14.575 11.4187 14.4808 11.0664C14.3866 10.7142 14.1565 10.4137 13.841 10.231L13.7378 10.1759C13.5277 10.0547 13.3535 9.88006 13.2326 9.66978C13.1118 9.45951 13.0486 9.22103 13.0496 8.97851V8.63442C13.0486 8.3919 13.1118 8.15342 13.2326 7.94315C13.3535 7.73287 13.5277 7.55826 13.7378 7.437L13.841 7.37507C14.1565 7.19232 14.3866 6.89186 14.4808 6.53963C14.575 6.18739 14.5255 5.81218 14.3434 5.49636L14.192 5.23485C14.0092 4.91935 13.7088 4.68925 13.3565 4.59506C13.0043 4.50088 12.6291 4.5503 12.3133 4.73249L12.21 4.78754C12.0008 4.90834 11.7635 4.97194 11.5219 4.97194C11.2803 4.97194 11.0429 4.90834 10.8337 4.78754L10.5378 4.6155C10.3287 4.49482 10.1551 4.32129 10.0343 4.11233C9.91356 3.90337 9.84985 3.66632 9.8496 3.42496V3.30109C9.8496 2.93606 9.70459 2.58598 9.44648 2.32787C9.18836 2.06975 8.83829 1.92474 8.47326 1.92474Z"
          stroke={
            disabled ? globalColors.disabledColor : globalColors.headingBlack
          }
          strokeWidth="2.06452"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.32202 7.43012C7.56189 7.43012 6.94568 8.04633 6.94568 8.80646C6.94568 9.56659 7.56189 10.1828 8.32202 10.1828C9.08216 10.1828 9.69837 9.56659 9.69837 8.80646C9.69837 8.04633 9.08216 7.43012 8.32202 7.43012ZM5.56934 8.80646C5.56934 7.28619 6.80176 6.05377 8.32202 6.05377C9.84229 6.05377 11.0747 7.28619 11.0747 8.80646C11.0747 10.3267 9.84229 11.5591 8.32202 11.5591C6.80176 11.5591 5.56934 10.3267 5.56934 8.80646Z"
          fill={
            disabled ? globalColors.disabledColor : globalColors.headingBlack
          }
        />
      </g>
      <defs>
        <clipPath id="clip0_293_4447">
          <rect
            width="16.5161"
            height="16.5161"
            fill="white"
            transform="translate(0.0644531 0.548393)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const UndoIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_248_680"
        //style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_248_680)">
        <path
          d="M6.66667 15.834C6.43056 15.834 6.2325 15.754 6.0725 15.594C5.91306 15.4345 5.83333 15.2368 5.83333 15.0007C5.83333 14.7645 5.91306 14.5668 6.0725 14.4073C6.2325 14.2473 6.43056 14.1673 6.66667 14.1673H11.75C12.625 14.1673 13.3853 13.8895 14.0308 13.334C14.6769 12.7784 15 12.084 15 11.2507C15 10.4173 14.6769 9.72288 14.0308 9.16732C13.3853 8.61177 12.625 8.33399 11.75 8.33399H6.5L8.08333 9.91732C8.23611 10.0701 8.3125 10.2645 8.3125 10.5007C8.3125 10.7368 8.23611 10.9312 8.08333 11.084C7.93056 11.2368 7.73611 11.3132 7.5 11.3132C7.26389 11.3132 7.06944 11.2368 6.91667 11.084L3.91667 8.08399C3.83333 8.00066 3.77417 7.91038 3.73917 7.81316C3.70472 7.71593 3.6875 7.61177 3.6875 7.50066C3.6875 7.38954 3.70472 7.28538 3.73917 7.18816C3.77417 7.09093 3.83333 7.00066 3.91667 6.91732L6.91667 3.91732C7.06944 3.76454 7.26389 3.68816 7.5 3.68816C7.73611 3.68816 7.93056 3.76454 8.08333 3.91732C8.23611 4.0701 8.3125 4.26454 8.3125 4.50066C8.3125 4.73677 8.23611 4.93121 8.08333 5.08399L6.5 6.66732H11.75C13.0972 6.66732 14.2536 7.10482 15.2192 7.97982C16.1842 8.85482 16.6667 9.9451 16.6667 11.2507C16.6667 12.5562 16.1842 13.6465 15.2192 14.5215C14.2536 15.3965 13.0972 15.834 11.75 15.834H6.66667Z"
          fill={disabled ? globalColors.disabledColor : "#65A0BA"}
        />
      </g>
    </svg>
  );
};

const RedoIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_248_686"
        //style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_248_686)">
        <path
          d="M8.24967 15.834C6.90245 15.834 5.74634 15.3965 4.78134 14.5215C3.81579 13.6465 3.33301 12.5562 3.33301 11.2507C3.33301 9.9451 3.81579 8.85482 4.78134 7.97982C5.74634 7.10482 6.90245 6.66732 8.24967 6.66732H13.4997L11.9163 5.08399C11.7636 4.93121 11.6872 4.73677 11.6872 4.50066C11.6872 4.26454 11.7636 4.0701 11.9163 3.91732C12.0691 3.76454 12.2636 3.68816 12.4997 3.68816C12.7358 3.68816 12.9302 3.76454 13.083 3.91732L16.083 6.91732C16.1663 7.00066 16.2255 7.09093 16.2605 7.18816C16.295 7.28538 16.3122 7.38954 16.3122 7.50066C16.3122 7.61177 16.295 7.71593 16.2605 7.81316C16.2255 7.91038 16.1663 8.00066 16.083 8.08399L13.083 11.084C12.9302 11.2368 12.7358 11.3132 12.4997 11.3132C12.2636 11.3132 12.0691 11.2368 11.9163 11.084C11.7636 10.9312 11.6872 10.7368 11.6872 10.5007C11.6872 10.2645 11.7636 10.0701 11.9163 9.91732L13.4997 8.33399H8.24967C7.37467 8.33399 6.6144 8.61177 5.96884 9.16732C5.32273 9.72288 4.99967 10.4173 4.99967 11.2507C4.99967 12.084 5.32273 12.7784 5.96884 13.334C6.6144 13.8895 7.37467 14.1673 8.24967 14.1673H13.333C13.5691 14.1673 13.7669 14.2473 13.9263 14.4073C14.0863 14.5668 14.1663 14.7645 14.1663 15.0007C14.1663 15.2368 14.0863 15.4345 13.9263 15.594C13.7669 15.754 13.5691 15.834 13.333 15.834H8.24967Z"
          fill={disabled ? globalColors.disabledColor : "#65A0BA"}
        />
      </g>
    </svg>
  );
};

const EditIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3732 1.66407C14.3275 1.6139 14.2721 1.5735 14.2104 1.54533C14.1487 1.51715 14.0819 1.50178 14.0141 1.50015C13.9463 1.49851 13.8788 1.51064 13.8158 1.53581C13.7528 1.56098 13.6956 1.59866 13.6475 1.64657L13.261 2.03126C13.2141 2.07814 13.1878 2.1417 13.1878 2.20798C13.1878 2.27425 13.2141 2.33782 13.261 2.3847L13.6154 2.73845C13.6386 2.76178 13.6662 2.7803 13.6966 2.79294C13.727 2.80558 13.7596 2.81208 13.7925 2.81208C13.8255 2.81208 13.8581 2.80558 13.8885 2.79294C13.9189 2.7803 13.9465 2.76178 13.9697 2.73845L14.3466 2.36345C14.5372 2.17313 14.555 1.86313 14.3732 1.66407ZM12.4794 2.81251L6.83816 8.44376C6.80396 8.47782 6.7791 8.52012 6.76598 8.56657L6.50504 9.34376C6.49879 9.36485 6.49834 9.38723 6.50376 9.40855C6.50917 9.42987 6.52023 9.44933 6.53579 9.46488C6.55134 9.48044 6.5708 9.4915 6.59212 9.49692C6.61344 9.50233 6.63583 9.50188 6.65691 9.49563L7.43348 9.2347C7.47993 9.22157 7.52222 9.19671 7.55629 9.16251L13.1875 3.52063C13.2396 3.46798 13.2689 3.3969 13.2689 3.32282C13.2689 3.24875 13.2396 3.17767 13.1875 3.12501L12.8766 2.81251C12.8239 2.75994 12.7525 2.73041 12.678 2.73041C12.6036 2.73041 12.5321 2.75994 12.4794 2.81251Z"
        fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
      />
      <path
        d="M12.0731 6.05188L8.26406 9.86844C8.11684 10.016 7.9359 10.1255 7.73688 10.1875L6.9275 10.4584C6.73542 10.5127 6.53234 10.5147 6.3392 10.4644C6.14606 10.414 5.96985 10.313 5.82871 10.1719C5.68758 10.0308 5.58662 9.85456 5.53626 9.66142C5.4859 9.46828 5.48794 9.26521 5.54219 9.07312L5.81313 8.26375C5.87492 8.06478 5.98421 7.88385 6.13156 7.73656L9.94812 3.92688C9.98311 3.89193 10.0069 3.8474 10.0166 3.7989C10.0263 3.75041 10.0214 3.70014 10.0025 3.65445C9.98357 3.60875 9.95154 3.56969 9.91044 3.5422C9.86934 3.51471 9.82101 3.50002 9.77156 3.5H3.25C2.78587 3.5 2.34075 3.68437 2.01256 4.01256C1.68437 4.34075 1.5 4.78587 1.5 5.25V12.75C1.5 13.2141 1.68437 13.6592 2.01256 13.9874C2.34075 14.3156 2.78587 14.5 3.25 14.5H10.75C11.2141 14.5 11.6592 14.3156 11.9874 13.9874C12.3156 13.6592 12.5 13.2141 12.5 12.75V6.22844C12.5 6.17899 12.4853 6.13066 12.4578 6.08956C12.4303 6.04846 12.3912 6.01643 12.3456 5.99753C12.2999 5.97864 12.2496 5.97371 12.2011 5.98338C12.1526 5.99306 12.1081 6.01689 12.0731 6.05188Z"
        fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
      />
    </svg>
  );
};

const SelectIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.50351 11.49L3.47017 8.45662C3.28794 8.27438 3.28794 7.9789 3.47017 7.79665L4.13013 7.13668C4.31236 6.95442 4.60786 6.95442 4.79009 7.13668L6.83349 9.18006L11.2102 4.80334C11.3925 4.62111 11.688 4.62111 11.8702 4.80334L12.5302 5.46331C12.7124 5.64555 12.7124 5.94103 12.5302 6.12328L7.16348 11.49C6.98122 11.6722 6.68575 11.6722 6.50351 11.49Z"
        fill={disabled ? globalColors.disabledColor : globalColors.headingBlack}
      />
    </svg>
  );
};

const DuplicateIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_380_4923)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.33301 6.66667C6.96481 6.66667 6.66634 6.96514 6.66634 7.33332V13.3333C6.66634 13.7015 6.96481 13.9999 7.33301 13.9999H13.333C13.7012 13.9999 13.9997 13.7015 13.9997 13.3333V7.33332C13.9997 6.96514 13.7012 6.66667 13.333 6.66667H7.33301ZM5.33301 7.33332C5.33301 6.22875 6.22844 5.33333 7.33301 5.33333H13.333C14.4376 5.33333 15.333 6.22875 15.333 7.33332V13.3333C15.333 14.4378 14.4376 15.3333 13.333 15.3333H7.33301C6.22844 15.3333 5.33301 14.4378 5.33301 13.3333V7.33332Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.6665 2C2.48969 2 2.32012 2.07024 2.1951 2.19526C2.07008 2.32029 1.99984 2.48986 1.99984 2.66667V8.66667C1.99984 8.84348 2.07008 9.01305 2.1951 9.13808C2.32012 9.2631 2.48969 9.33334 2.6665 9.33334H3.33317C3.70136 9.33334 3.99984 9.63182 3.99984 10C3.99984 10.3682 3.70136 10.6667 3.33317 10.6667H2.6665C2.13607 10.6667 1.62736 10.456 1.25229 10.0809C0.877217 9.70581 0.666504 9.1971 0.666504 8.66667V2.66667C0.666504 2.13623 0.877217 1.62753 1.25229 1.25245C1.62736 0.87738 2.13607 0.666667 2.6665 0.666667H8.6665C9.19694 0.666667 9.70564 0.87738 10.0807 1.25245C10.4558 1.62753 10.6665 2.13623 10.6665 2.66667V3.33333C10.6665 3.70152 10.368 4 9.99984 4C9.63165 4 9.33317 3.70152 9.33317 3.33333V2.66667C9.33317 2.48986 9.26293 2.32029 9.13791 2.19526C9.01288 2.07024 8.84332 2 8.6665 2H2.6665Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
      </g>
      <defs>
        <clipPath id="clip0_380_4923">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CopyLinkIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_380_4918)">
        <path
          d="M4.7812 9.05309C4.75453 8.87314 4.66788 8.71317 4.53456 8.56654L2.62147 6.55366C2.08821 5.99379 1.83491 5.32727 1.85491 4.56744C1.8749 3.80095 2.16153 3.15443 2.72146 2.62122C3.28805 2.08801 3.94797 1.83473 4.71454 1.85473C5.47444 1.87472 6.12102 2.16799 6.65429 2.72786L8.56738 4.74074C8.6607 4.84072 8.76068 4.91403 8.874 4.96069L10.0938 3.74096C10.0539 3.64099 9.99386 3.55434 9.91387 3.46769L8.00078 1.44815C7.12089 0.521694 6.04103 0.0351373 4.7612 0.0018115C3.48136 -0.0315143 2.38151 0.395056 1.44829 1.27486C0.521745 2.16132 0.0351407 3.23441 0.00181168 4.51412C-0.0315174 5.79383 0.395094 6.89358 1.27498 7.82671L3.18807 9.84625C3.33472 9.99955 3.51469 10.0929 3.708 10.1262L4.7812 9.05309Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
        <path
          d="M4.30126 3.40771C4.04796 3.40771 3.82799 3.48769 3.63468 3.67431C3.44803 3.85427 3.34805 4.06756 3.34138 4.32083C3.33472 4.56744 3.42137 4.78739 3.60135 4.98068L6.18768 7.64675L7.50085 6.33371L4.94784 3.70764C4.76786 3.51435 4.54789 3.41437 4.30126 3.40771Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
        <path
          d="M10.4938 12.0791L10.5938 12.1791C10.7738 12.3723 10.9871 12.4657 11.2404 12.4723C11.487 12.479 11.7136 12.3923 11.9003 12.2124C12.0936 12.0324 12.1936 11.8191 12.2002 11.5659C12.2069 11.3126 12.1136 11.0926 11.9336 10.906L11.8003 10.7727L10.4938 12.0791Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
        <path
          d="M13.0801 9.493C13.5801 10.0462 13.82 10.6927 13.8 11.4392C13.78 12.199 13.4867 12.8456 12.9268 13.3788C12.3669 13.912 11.707 14.1653 10.9404 14.1453C10.2472 14.1253 9.64724 13.892 9.1473 13.4254L7.8408 14.7318C8.68069 15.545 9.70056 15.9649 10.8937 15.9982C12.1669 16.0315 13.2734 15.6049 14.2 14.7251C15.1332 13.8453 15.6131 12.7656 15.6531 11.4859C15.6865 10.2128 15.2665 9.11975 14.3866 8.18662L13.0801 9.493Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
        <path
          d="M14.8666 6.29372H14.8532L15.6131 5.52723C15.8798 5.26062 16.0064 4.94069 15.9998 4.56744C15.9864 4.18753 15.8464 3.8676 15.5798 3.601L14.6066 2.62788C14.34 2.36128 14.0133 2.22797 13.6267 2.22797C13.2401 2.22797 12.9068 2.36128 12.6402 2.62788L11.9203 3.34772H11.9069L3.49469 11.7525C3.42804 11.8191 3.37471 11.8991 3.34138 11.9858C3.30805 12.0724 3.28805 12.1657 3.28805 12.259V14.2186C3.28805 14.4185 3.35471 14.5852 3.48803 14.7185C3.62135 14.8518 3.78799 14.9184 3.9813 14.9184H5.94771C6.04103 14.9184 6.12769 14.8984 6.22101 14.8651C6.30767 14.8318 6.38099 14.7785 6.45431 14.7051L14.8666 6.29372ZM5.65442 13.5254H4.68121V12.5523L11.9269 5.30728L12.9002 6.28039L5.65442 13.5254Z"
          fill={disabled ? globalColors.disabledColor : "#4A4B4D"}
        />
      </g>
      <defs>
        <clipPath id="clip0_380_4918">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const DeleteForeverIcon = ({ disabled }: ButtonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.18262 4.67743C2.18262 4.29736 2.49072 3.98926 2.87079 3.98926H15.2579C15.638 3.98926 15.9461 4.29736 15.9461 4.67743C15.9461 5.0575 15.638 5.3656 15.2579 5.3656H2.87079C2.49072 5.3656 2.18262 5.0575 2.18262 4.67743Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6886 2.61291C7.50609 2.61291 7.33105 2.68541 7.20199 2.81447C7.07293 2.94353 7.00043 3.11857 7.00043 3.30108V3.98925H11.1295V3.30108C11.1295 3.11857 11.057 2.94353 10.9279 2.81447C10.7988 2.68541 10.6238 2.61291 10.4413 2.61291H7.6886ZM12.5058 3.98925V3.30108C12.5058 2.75354 12.2883 2.22842 11.9011 1.84125C11.514 1.45408 10.9888 1.23656 10.4413 1.23656H7.6886C7.14106 1.23656 6.61594 1.45408 6.22877 1.84125C5.8416 2.22842 5.62409 2.75354 5.62409 3.30108V3.98925H4.24774C3.86768 3.98925 3.55957 4.29736 3.55957 4.67743V14.3118C3.55957 14.8594 3.77708 15.3845 4.16425 15.7717C4.55142 16.1588 5.07654 16.3764 5.62409 16.3764H12.5058C13.0534 16.3764 13.5785 16.1588 13.9656 15.7717C14.3528 15.3845 14.5703 14.8594 14.5703 14.3118V4.67743C14.5703 4.29736 14.2622 3.98925 13.8822 3.98925H12.5058ZM4.93591 5.3656V14.3118C4.93591 14.4943 5.00842 14.6694 5.13748 14.7984C5.26653 14.9275 5.44157 15 5.62409 15H12.5058C12.6883 15 12.8634 14.9275 12.9924 14.7984C13.1215 14.6694 13.194 14.4943 13.194 14.3118V5.3656H4.93591Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68817 7.43011C8.06824 7.43011 8.37634 7.73822 8.37634 8.11829V12.2473C8.37634 12.6274 8.06824 12.9355 7.68817 12.9355C7.30811 12.9355 7 12.6274 7 12.2473V8.11829C7 7.73822 7.30811 7.43011 7.68817 7.43011Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4411 7.43011C10.8212 7.43011 11.1293 7.73822 11.1293 8.11829V12.2473C11.1293 12.6274 10.8212 12.9355 10.4411 12.9355C10.061 12.9355 9.75293 12.6274 9.75293 12.2473V8.11829C9.75293 7.73822 10.061 7.43011 10.4411 7.43011Z"
        fill={disabled ? globalColors.disabledColor : globalColors.white}
      />
    </svg>
  );
};

const SidebarDeleteIcon = ({ isSelected }: SidebarIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_564_2147)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.3335 4.00001C1.3335 3.63182 1.63197 3.33334 2.00016 3.33334H14.0002C14.3684 3.33334 14.6668 3.63182 14.6668 4.00001C14.6668 4.3682 14.3684 4.66668 14.0002 4.66668H2.00016C1.63197 4.66668 1.3335 4.3682 1.3335 4.00001Z"
          fill={isSelected ? globalColors.calmLightDark : globalColors.textGrey}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6665 1.99999C6.48969 1.99999 6.32012 2.07023 6.1951 2.19525C6.07007 2.32028 5.99984 2.48985 5.99984 2.66666V3.33332H9.99984V2.66666C9.99984 2.48985 9.9296 2.32028 9.80457 2.19525C9.67955 2.07023 9.50998 1.99999 9.33317 1.99999H6.6665ZM11.3332 3.33332V2.66666C11.3332 2.13622 11.1225 1.62752 10.7474 1.25244C10.3723 0.87737 9.8636 0.666656 9.33317 0.666656H6.6665C6.13607 0.666656 5.62736 0.87737 5.25229 1.25244C4.87722 1.62752 4.6665 2.13622 4.6665 2.66666V3.33332H3.33317C2.96498 3.33332 2.6665 3.6318 2.6665 3.99999V13.3333C2.6665 13.8638 2.87722 14.3725 3.25229 14.7475C3.62736 15.1226 4.13607 15.3333 4.6665 15.3333H11.3332C11.8636 15.3333 12.3723 15.1226 12.7474 14.7475C13.1225 14.3725 13.3332 13.8638 13.3332 13.3333V3.99999C13.3332 3.6318 13.0347 3.33332 12.6665 3.33332H11.3332ZM3.99984 4.66666V13.3333C3.99984 13.5101 4.07007 13.6797 4.1951 13.8047C4.32012 13.9298 4.48969 14 4.6665 14H11.3332C11.51 14 11.6795 13.9298 11.8046 13.8047C11.9296 13.6797 11.9998 13.5101 11.9998 13.3333V4.66666H3.99984Z"
          fill={isSelected ? globalColors.calmLightDark : globalColors.textGrey}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66667 6.66666C7.03486 6.66666 7.33333 6.96513 7.33333 7.33332V11.3333C7.33333 11.7015 7.03486 12 6.66667 12C6.29848 12 6 11.7015 6 11.3333V7.33332C6 6.96513 6.29848 6.66666 6.66667 6.66666Z"
          fill={isSelected ? globalColors.calmLightDark : globalColors.textGrey}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33317 6.66666C9.70136 6.66666 9.99984 6.96513 9.99984 7.33332V11.3333C9.99984 11.7015 9.70136 12 9.33317 12C8.96498 12 8.6665 11.7015 8.6665 11.3333V7.33332C8.6665 6.96513 8.96498 6.66666 9.33317 6.66666Z"
          fill={isSelected ? globalColors.calmLightDark : globalColors.textGrey}
        />
      </g>
      <defs>
        <clipPath id="clip0_564_2147">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SidebarDraftIcon = ({ isSelected }: SidebarIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_564_2134)">
        <g clipPath="url(#clip1_564_2134)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5288 0.861934C11.7891 0.601584 12.2112 0.601584 12.4716 0.861934L15.1382 3.5286C15.3986 3.78895 15.3986 4.21106 15.1382 4.47141C14.8779 4.73176 14.4558 4.73176 14.1954 4.47141L11.5288 1.80474C11.2684 1.54439 11.2684 1.12228 11.5288 0.861934Z"
            fill={
              isSelected ? globalColors.calmLightDark : globalColors.textGrey
            }
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.52845 2.86193C9.7888 2.60158 10.2109 2.60158 10.4713 2.86193L13.1379 5.5286C13.3983 5.78895 13.3983 6.21106 13.1379 6.47141L5.47126 14.1381C5.38922 14.2201 5.28719 14.2793 5.17526 14.3098L1.5086 15.3098C1.27779 15.3728 1.03095 15.3072 0.861782 15.1381C0.692615 14.9689 0.627062 14.7221 0.69001 14.4913L1.69001 10.8246C1.72054 10.7127 1.77974 10.6106 1.86178 10.5286L9.52845 2.86193ZM2.92978 11.3462L2.28333 13.7165L4.65364 13.0701L11.7237 6L9.99985 4.27615L2.92978 11.3462Z"
            fill={
              isSelected ? globalColors.calmLightDark : globalColors.textGrey
            }
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_564_2134">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_564_2134">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SidebarPublishIcon = ({ isSelected }: SidebarIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_564_2122)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.66683 2.66666V12.7972L7.82074 10.826C8.03692 10.6909 8.31123 10.6909 8.52741 10.826L11.6813 12.7972V2.66666H4.66683ZM3.68157 1.6814C3.90444 1.45854 4.20672 1.33333 4.5219 1.33333H11.8263C12.1414 1.33333 12.4437 1.45853 12.6666 1.6814C12.8895 1.90427 13.0147 2.20655 13.0147 2.52173V14C13.0147 14.2423 12.8831 14.4656 12.6712 14.5831C12.4592 14.7006 12.2002 14.6938 11.9947 14.5653L8.17408 12.1775L4.3535 14.5653C4.14798 14.6938 3.88895 14.7006 3.67698 14.5831C3.46501 14.4656 3.3335 14.2423 3.3335 14V2.52173C3.3335 2.20655 3.4587 1.90427 3.68157 1.6814Z"
          fill={isSelected ? globalColors.calmLightDark : globalColors.textGrey}
        />
      </g>
      <defs>
        <clipPath id="clip0_564_2122">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SidebarSubmissionIcon = ({ isSelected }: SidebarIconProps) => {
  return (
    <svg width="14" height="16" viewBox="0 0 29 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1H14C21.732 1 28 7.26801 28 15V33H1V1Z" stroke={isSelected ? globalColors.calmLightDark : globalColors.textGrey} strokeWidth="3" />
      <line x1="6.5" y1="8.25" x2="21.5" y2="8.25" stroke={isSelected ? globalColors.calmLightDark : globalColors.textGrey} strokeWidth="2" />
      <path d="M20 17.5L11.75 25.75L8 22" stroke={isSelected ? globalColors.calmLightDark : globalColors.textGrey} strokeWidth="3" strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
};

const PreviewDesktopIcon = ({ isSelected }: PreviewIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 25.3333C9.62255 25.3333 9.3061 25.2053 9.05099 24.9493C8.79499 24.6942 8.66699 24.3778 8.66699 24C8.66699 23.6222 8.79499 23.3058 9.05099 23.0507C9.3061 22.7947 9.62255 22.6667 10.0003 22.6667H11.3337V20H3.33366C2.60033 20 1.97277 19.7391 1.45099 19.2173C0.928326 18.6947 0.666992 18.0667 0.666992 17.3333V2.66667C0.666992 1.93333 0.928326 1.30533 1.45099 0.782667C1.97277 0.260889 2.60033 0 3.33366 0H24.667C25.4003 0 26.0283 0.260889 26.551 0.782667C27.0728 1.30533 27.3337 1.93333 27.3337 2.66667V17.3333C27.3337 18.0667 27.0728 18.6947 26.551 19.2173C26.0283 19.7391 25.4003 20 24.667 20H16.667V22.6667H18.0003C18.3781 22.6667 18.695 22.7947 18.951 23.0507C19.2061 23.3058 19.3337 23.6222 19.3337 24C19.3337 24.3778 19.2061 24.6942 18.951 24.9493C18.695 25.2053 18.3781 25.3333 18.0003 25.3333H10.0003ZM3.33366 17.3333H24.667V2.66667H3.33366V17.3333Z"
        fill={isSelected ? globalColors.white : globalColors.primary}
      />
    </svg>
  );
};

const PreviewTabletIcon = ({ isSelected }: PreviewIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 29.6667C1.93333 29.6667 1.30533 29.4058 0.782667 28.884C0.260889 28.3613 0 27.7333 0 27V2.99999C0 2.26666 0.260889 1.63866 0.782667 1.11599C1.30533 0.594217 1.93333 0.333328 2.66667 0.333328H21.3333C22.0667 0.333328 22.6947 0.594217 23.2173 1.11599C23.7391 1.63866 24 2.26666 24 2.99999V27C24 27.7333 23.7391 28.3613 23.2173 28.884C22.6947 29.4058 22.0667 29.6667 21.3333 29.6667H2.66667ZM2.66667 20.3333H21.3333V7H2.66667V20.3333ZM2.66667 23V27H21.3333V23H2.66667ZM2.66667 4.33333H21.3333V2.99999H2.66667V4.33333ZM12 26.3333C12.3778 26.3333 12.6947 26.2053 12.9507 25.9493C13.2058 25.6942 13.3333 25.3778 13.3333 25C13.3333 24.6222 13.2058 24.3058 12.9507 24.0507C12.6947 23.7947 12.3778 23.6667 12 23.6667C11.6222 23.6667 11.3058 23.7947 11.0507 24.0507C10.7947 24.3058 10.6667 24.6222 10.6667 25C10.6667 25.3778 10.7947 25.6942 11.0507 25.9493C11.3058 26.2053 11.6222 26.3333 12 26.3333Z"
        fill={isSelected ? globalColors.white : globalColors.primary}
      />
    </svg>
  );
};

const PreviewMobileIcon = ({ isSelected }: PreviewIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 26.3333C10.3781 26.3333 10.695 26.2053 10.951 25.9493C11.2061 25.6942 11.3337 25.3778 11.3337 25C11.3337 24.6222 11.2061 24.3058 10.951 24.0507C10.695 23.7947 10.3781 23.6667 10.0003 23.6667C9.62255 23.6667 9.3061 23.7947 9.05099 24.0507C8.79499 24.3058 8.66699 24.6222 8.66699 25C8.66699 25.3778 8.79499 25.6942 9.05099 25.9493C9.3061 26.2053 9.62255 26.3333 10.0003 26.3333ZM3.33366 20.3333H16.667V7H3.33366V20.3333ZM3.33366 29.6667C2.60033 29.6667 1.97277 29.4058 1.45099 28.884C0.928325 28.3613 0.666992 27.7333 0.666992 27V2.99999C0.666992 2.26666 0.928325 1.63866 1.45099 1.11599C1.97277 0.594217 2.60033 0.333328 3.33366 0.333328H16.667C17.4003 0.333328 18.0283 0.594217 18.551 1.11599C19.0728 1.63866 19.3337 2.26666 19.3337 2.99999V27C19.3337 27.7333 19.0728 28.3613 18.551 28.884C18.0283 29.4058 17.4003 29.6667 16.667 29.6667H3.33366ZM3.33366 4.33333H16.667V2.99999H3.33366V4.33333ZM3.33366 23V27H16.667V23H3.33366Z"
        fill={isSelected ? globalColors.white : globalColors.primary}
      />
    </svg>
  );
};

const ContentScreenPlusIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4997 25.3333C17.9719 25.3333 18.368 25.1733 18.688 24.8533C19.0069 24.5345 19.1663 24.1389 19.1663 23.6667V18.6667H24.208C24.6802 18.6667 25.0691 18.5067 25.3747 18.1867C25.6802 17.8678 25.833 17.4722 25.833 17C25.833 16.5278 25.673 16.1317 25.353 15.8117C25.0341 15.4928 24.6386 15.3333 24.1663 15.3333H19.1663V10.2917C19.1663 9.81945 19.0069 9.43057 18.688 9.12501C18.368 8.81945 17.9719 8.66668 17.4997 8.66668C17.0275 8.66668 16.6319 8.82612 16.313 9.14501C15.993 9.46501 15.833 9.86112 15.833 10.3333V15.3333H10.7913C10.3191 15.3333 9.93023 15.4928 9.62467 15.8117C9.31912 16.1317 9.16634 16.5278 9.16634 17C9.16634 17.4722 9.32579 17.8678 9.64467 18.1867C9.96467 18.5067 10.3608 18.6667 10.833 18.6667H15.833V23.7083C15.833 24.1806 15.993 24.5695 16.313 24.875C16.6319 25.1806 17.0275 25.3333 17.4997 25.3333ZM17.4997 33.6667C15.1941 33.6667 13.0275 33.2289 10.9997 32.3533C8.9719 31.4789 7.20801 30.2917 5.70801 28.7917C4.20801 27.2917 3.02079 25.5278 2.14634 23.5C1.27079 21.4722 0.833008 19.3056 0.833008 17C0.833008 14.6945 1.27079 12.5278 2.14634 10.5C3.02079 8.47223 4.20801 6.70834 5.70801 5.20834C7.20801 3.70834 8.9719 2.52057 10.9997 1.64501C13.0275 0.770566 15.1941 0.333344 17.4997 0.333344C19.8052 0.333344 21.9719 0.770566 23.9997 1.64501C26.0275 2.52057 27.7913 3.70834 29.2913 5.20834C30.7913 6.70834 31.9786 8.47223 32.853 10.5C33.7286 12.5278 34.1663 14.6945 34.1663 17C34.1663 19.3056 33.7286 21.4722 32.853 23.5C31.9786 25.5278 30.7913 27.2917 29.2913 28.7917C27.7913 30.2917 26.0275 31.4789 23.9997 32.3533C21.9719 33.2289 19.8052 33.6667 17.4997 33.6667Z"
        fill="#65A0BA"
      />
    </svg>
  );
};

const ContentScreenAddIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99967 0.666687C6.36786 0.666687 6.66634 0.965164 6.66634 1.33335V10.6667C6.66634 11.0349 6.36786 11.3334 5.99967 11.3334C5.63148 11.3334 5.33301 11.0349 5.33301 10.6667V1.33335C5.33301 0.965164 5.63148 0.666687 5.99967 0.666687Z"
        fill={disabled ? globalColors.disabledColor : color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666504 6.00004C0.666504 5.63185 0.964981 5.33337 1.33317 5.33337H10.6665C11.0347 5.33337 11.3332 5.63185 11.3332 6.00004C11.3332 6.36823 11.0347 6.66671 10.6665 6.66671H1.33317C0.964981 6.66671 0.666504 6.36823 0.666504 6.00004Z"
        fill={disabled ? globalColors.disabledColor : color}
      />
    </svg>
  );
};

const ContentScreenDeleteIcon = ({ color, disabled, onClick }: ButtonIconProps) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => onClick && onClick()}
    >
      <path
        d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3C0.716667 3 0.479 2.90433 0.287 2.713C0.0956668 2.521 0 2.28333 0 2C0 1.71667 0.0956668 1.479 0.287 1.287C0.479 1.09567 0.716667 1 1 1H5C5 0.716667 5.096 0.479 5.288 0.287C5.47933 0.0956666 5.71667 0 6 0H10C10.2833 0 10.521 0.0956666 10.713 0.287C10.9043 0.479 11 0.716667 11 1H15C15.2833 1 15.5207 1.09567 15.712 1.287C15.904 1.479 16 1.71667 16 2C16 2.28333 15.904 2.521 15.712 2.713C15.5207 2.90433 15.2833 3 15 3V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM3 3V16H13V3H3ZM5 13C5 13.2833 5.096 13.5207 5.288 13.712C5.47933 13.904 5.71667 14 6 14C6.28333 14 6.521 13.904 6.713 13.712C6.90433 13.5207 7 13.2833 7 13V6C7 5.71667 6.90433 5.479 6.713 5.287C6.521 5.09567 6.28333 5 6 5C5.71667 5 5.47933 5.09567 5.288 5.287C5.096 5.479 5 5.71667 5 6V13ZM9 13C9 13.2833 9.096 13.5207 9.288 13.712C9.47933 13.904 9.71667 14 10 14C10.2833 14 10.521 13.904 10.713 13.712C10.9043 13.5207 11 13.2833 11 13V6C11 5.71667 10.9043 5.479 10.713 5.287C10.521 5.09567 10.2833 5 10 5C9.71667 5 9.47933 5.09567 9.288 5.287C9.096 5.479 9 5.71667 9 6V13Z"
        fill={disabled ? globalColors.disabledColor : color}
      />
    </svg>
  );
};

const ContentScreenClipboardIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 16C5.45 16 4.97933 15.8043 4.588 15.413C4.196 15.021 4 14.55 4 14V2C4 1.45 4.196 0.979 4.588 0.587C4.97933 0.195667 5.45 0 6 0H15C15.55 0 16.021 0.195667 16.413 0.587C16.8043 0.979 17 1.45 17 2V14C17 14.55 16.8043 15.021 16.413 15.413C16.021 15.8043 15.55 16 15 16H6ZM6 14H15V2H6V14ZM2 20C1.45 20 0.979 19.8043 0.587 19.413C0.195667 19.021 0 18.55 0 18V5C0 4.71667 0.0960001 4.479 0.288 4.287C0.479333 4.09567 0.716667 4 1 4C1.28333 4 1.521 4.09567 1.713 4.287C1.90433 4.479 2 4.71667 2 5V18H12C12.2833 18 12.521 18.096 12.713 18.288C12.9043 18.4793 13 18.7167 13 19C13 19.2833 12.9043 19.5207 12.713 19.712C12.521 19.904 12.2833 20 12 20H2Z"
        fill={disabled ? globalColors.disabledColor : color}
      />
    </svg>
  );
};

const ContentScreenDragIcon = ({ color, disabled }: ButtonIconProps) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7.1201C8.73368 7.1201 8.5106 7.02987 8.33076 6.8494C8.15029 6.66956 8.06005 6.44647 8.06005 6.18016V3.21932L7.02611 4.25326C6.83812 4.44125 6.61504 4.53525 6.35687 4.53525C6.09807 4.53525 5.87467 4.44125 5.68668 4.25326C5.49869 4.06527 5.4047 3.84188 5.4047 3.58308C5.4047 3.32491 5.49869 3.10183 5.68668 2.91384L8.34204 0.258486C8.43603 0.164491 8.53786 0.0977546 8.64752 0.0582768C8.75718 0.0194256 8.87467 0 9 0C9.12533 0 9.24282 0.0194256 9.35248 0.0582768C9.46214 0.0977546 9.56397 0.164491 9.65796 0.258486L12.3368 2.93734C12.5248 3.12533 12.615 3.34841 12.6075 3.60658C12.5994 3.86538 12.5013 4.08877 12.3133 4.27676C12.1253 4.46475 11.8982 4.55875 11.6319 4.55875C11.3655 4.55875 11.1384 4.46475 10.9504 4.27676L9.93995 3.21932V6.18016C9.93995 6.44647 9.85003 6.66956 9.67018 6.8494C9.48971 7.02987 9.26632 7.1201 9 7.1201ZM9 18C8.87467 18 8.75718 17.9803 8.64752 17.9408C8.53786 17.9019 8.43603 17.8355 8.34204 17.7415L5.66318 15.0627C5.47519 14.8747 5.38527 14.6513 5.39342 14.3925C5.40094 14.1343 5.49869 13.9112 5.68668 13.7232C5.87467 13.5352 6.1059 13.4372 6.38037 13.429C6.6542 13.4215 6.87728 13.5196 7.04961 13.7232L8.06005 14.7807V11.8198C8.06005 11.5535 8.15029 11.3301 8.33076 11.1497C8.5106 10.9698 8.73368 10.8799 9 10.8799C9.26632 10.8799 9.48971 10.9698 9.67018 11.1497C9.85003 11.3301 9.93995 11.5535 9.93995 11.8198V14.7807L10.9739 13.7232C11.1462 13.5352 11.3655 13.4413 11.6319 13.4413C11.8982 13.4413 12.1253 13.5352 12.3133 13.7232C12.5013 13.9112 12.5953 14.1384 12.5953 14.4047C12.5953 14.671 12.5013 14.8982 12.3133 15.0862L9.65796 17.7415C9.56397 17.8355 9.46214 17.9019 9.35248 17.9408C9.24282 17.9803 9.12533 18 9 18ZM13.7232 12.3133C13.5352 12.1253 13.4372 11.8941 13.429 11.6196C13.4215 11.3458 13.5196 11.1227 13.7232 10.9504L14.7807 9.93995H11.8198C11.5535 9.93995 11.3304 9.84971 11.1506 9.66924C10.9701 9.4894 10.8799 9.26632 10.8799 9C10.8799 8.73368 10.9701 8.51029 11.1506 8.32982C11.3304 8.14997 11.5535 8.06005 11.8198 8.06005H14.7807L13.7232 7.02611C13.5352 6.85379 13.4413 6.63446 13.4413 6.36815C13.4413 6.10183 13.5352 5.87467 13.7232 5.68668C13.9112 5.49869 14.1384 5.4047 14.4047 5.4047C14.671 5.4047 14.8982 5.49869 15.0862 5.68668L17.7415 8.34204C17.8355 8.43603 17.9022 8.53786 17.9417 8.64752C17.9806 8.75718 18 8.87467 18 9C18 9.12533 17.9806 9.24282 17.9417 9.35248C17.9022 9.46214 17.8355 9.56397 17.7415 9.65796L15.0627 12.3368C14.8747 12.5248 14.6516 12.6147 14.3934 12.6066C14.1346 12.5991 13.9112 12.5013 13.7232 12.3133ZM2.91384 12.3133L0.258486 9.65796C0.164491 9.56397 0.0980678 9.46214 0.0592167 9.35248C0.0197389 9.24282 0 9.12533 0 9C0 8.87467 0.0197389 8.75718 0.0592167 8.64752C0.0980678 8.53786 0.164491 8.43603 0.258486 8.34204L2.93734 5.66318C3.10966 5.49086 3.32522 5.4047 3.58402 5.4047C3.84219 5.4047 4.06527 5.49869 4.25326 5.68668C4.44125 5.87467 4.53149 6.10183 4.52397 6.36815C4.51582 6.63446 4.41775 6.86162 4.22976 7.04961L3.21932 8.06005H6.18016C6.44647 8.06005 6.66987 8.14997 6.85034 8.32982C7.03018 8.51029 7.1201 8.73368 7.1201 9C7.1201 9.26632 7.03018 9.4894 6.85034 9.66924C6.66987 9.84971 6.44647 9.93995 6.18016 9.93995H3.21932L4.27676 10.9739C4.46475 11.1462 4.55875 11.3655 4.55875 11.6319C4.55875 11.8982 4.46475 12.1253 4.27676 12.3133C4.08877 12.5013 3.86162 12.5953 3.5953 12.5953C3.32898 12.5953 3.10183 12.5013 2.91384 12.3133Z"
        fill={disabled ? globalColors.disabledColor : color}
      />
    </svg>
  );
};

export {
  AddIcon,
  ContentScreenAddIcon,
  ContentScreenClipboardIcon,
  ContentScreenDeleteIcon,
  ContentScreenDragIcon,
  ContentScreenPlusIcon,
  CopyLinkIcon,
  DeleteForeverIcon,
  DeleteIcon,
  DuplicateIcon,
  EditIcon,
  PreviewIcon,
  ShareIcon,
  PreviewDesktopIcon,
  PreviewMobileIcon,
  PreviewTabletIcon,
  PublishIcon,
  RedoIcon,
  SaveIcon,
  SelectIcon,
  SettingsIcon,
  SidebarDeleteIcon,
  SidebarDraftIcon,
  SidebarPublishIcon,
  UndoIcon,
  UnPublishIcon,
  SidebarSubmissionIcon,
  OpenFormIcon
};
